module.exports = __webpack_public_path__ + "img/homepage_1--mobile@2x.dcf40298.jpg";